/**
 * Button for VoxPop created by karora on 16/06/17.
 */
import {Component} from "@angular/core";

@Component({
  moduleId: module.id,
  selector: 'voxbtn',
  template: '<button></button>',
  styles: [
`.container { color: white; }
  
.button {
  display: inline-block;
  padding: 0.2em 0.4em;
  border-radius: 0.1em;
  border: 2px solid #3e2723;
  background-color: #6d4c41;
  color: white;
}
.button:hover {
  border: 2px solid #1b5e20;
  background-color: #4caf50;
}
`],
  providers: [],
})


export class VoxBtn {

  constructor(
  ) { }

}
